import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/public-module/public.module').then(m => m.PublicModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth-module/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'private',
    loadChildren: () => import('./pages/private-module/private.module').then(m => m.PrivateModule),
  },
  {
    path: 'recover',
    loadChildren: () => import('./pages/auth-module//pages/recover-password/recover-password.module').then( m => m.RecoverPasswordPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
